// File validation utility functions for WebView creatives
// TODO: For future extensibility, consider returning error messages instead of calling Toast directly (to decouple validation from UI).

const MAX_IMAGES = 4;
const MAX_SIZE = 5 * 1024 * 1024; // 5MB
const MAX_VIDEO_SIZE = 20 * 1024 * 1024; // 20MB
const MAX_AUDIO_SIZE = 10 * 1024 * 1024; // 10MB
const MAX_HTML_SIZE = 2 * 1024 * 1024; // 2MB
const ALLOWED_IMAGE_TYPES = ["image/jpg", "image/jpeg", "image/webp", "image/png"];
const ALLOWED_GIF_TYPES = ["image/gif"]; 
const ALLOWED_VIDEO_TYPES = ["video/mp4", "video/webm"];
const ALLOWED_AUDIO_TYPES = ["audio/mp3", "audio/wav", "audio/aac", "audio/ogg", "audio/mpeg"];
const ALLOWED_HTML_TYPES = ["text/html"];

export function validateFiles({ files, type, Toast }) {
  if (type === 'image' || type === 'swiper' || type === 'multi_creative_swiper') {
    if (files.length < 1) return Toast('error', 'Select at least 1 image'), false;
    if (files.length > MAX_IMAGES) return Toast('error', `You can upload up to ${MAX_IMAGES} images`), false;
    for (let file of files) {
      if (!ALLOWED_IMAGE_TYPES.includes(file.type)) return Toast('error', `Invalid file type: ${file.name}`), false;
      if (file.size > MAX_SIZE) return Toast('error', `${file.name} is too large (max 5MB)`), false;
    }
    return true;
  }
  if (type === 'static_image') {
    if (files.length !== 1) return Toast('error', 'Select exactly 1 image'), false;
    const file = files[0];
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) return Toast('error', `Invalid file type: ${file.name}`), false;
    if (file.size > MAX_SIZE) return Toast('error', `${file.name} is too large (max 5MB)`), false;
    return true;
  }
  if (type === 'gif') {
    if (files.length !== 1) return Toast('error', 'Select exactly 1 GIF file'), false;
    for (let file of files) {
      if (!(ALLOWED_GIF_TYPES.includes(file.type) || ALLOWED_IMAGE_TYPES.includes(file.type))) return Toast('error', `Invalid file type: ${file.name}`), false;
      if (file.size > MAX_SIZE) return Toast('error', `${file.name} is too large (max 5MB)`), false;
    }
    return true;
  }
  if (type === 'video') {
    if (files.length !== 1) return Toast('error', 'Select exactly 1 video file'), false;
    const file = files[0];
    if (!ALLOWED_VIDEO_TYPES.includes(file.type)) return Toast('error', `Invalid file type: ${file.name}. Only MP4 and WebM files are allowed.`), false;
    if (file.size > MAX_VIDEO_SIZE) return Toast('error', `${file.name} is too large (max 20MB)`), false;
    return true;
  }
  if (type === 'upload_file') {
    if (files.length !== 1) return Toast('error', 'Select exactly 1 HTML file'), false;
    const file = files[0];
    if (!ALLOWED_HTML_TYPES.includes(file.type)) return Toast('error', `Invalid file type: ${file.name}. Only HTML files are allowed.`), false;
    if (file.size > MAX_HTML_SIZE) return Toast('error', `${file.name} is too large (max 2MB)`), false;
    return true;
  }
  return false;
}

export function validateAudioFile(file, Toast) {
  if (!ALLOWED_AUDIO_TYPES.includes(file.type)) {
    Toast('error', `Invalid audio file type: ${file.name}`);
    return false;
  }
  if (file.size > MAX_AUDIO_SIZE) {
    Toast('error', `${file.name} is too large (max 10MB)`);
    return false;
  }
  return true;
}

export function isValidUrl(string) {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
} 